<template>
    <FormControl
        label="Describe your availability"
        required
        :error="
            errors.getValidationError(
                RequestBodyKeyEnum.App_Availability_AiPrompt,
            )
        "
    >
        <TextareaInput
            :name="RequestBodyKeyEnum.App_Availability_AiPrompt"
            rows="5"
            required
            placeholder="Ex: Weekdays from 09:00 to 17:00, except next Friday off. Saturdays 10 to 14."
        />
        <template #helperText>
            Describe recurring weekly hours and specific date exceptions in
            plain language.
        </template>
    </FormControl>
</template>

<script setup lang="ts">
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import TextareaInput from '@/Shared/Component/Forms/TextareaInput.vue'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    interface AvailabilityAiFormProps {
        errors: ApiFormErrors
    }

    const props = defineProps<AvailabilityAiFormProps>()
</script>
